/// <reference path="skyward.base.global.js" />
/// <reference path="skyward.ui.window.js" />
/// <reference path="skyward.ui.controls.js" />
/// <reference path="skyward.ui.modallayer.js" />
(
    function (skyward, $, undefined)
    {
        skyward.mtss = skyward.mtss || {};

        var filterData =
        {
            CheckpointDate: null,
            SelectedStudents: null,
            SelectedStrategies: null,
            ShowAllRecords: false,
            Portal: ""
        };
        var dmseIsOpen = false;

        var init = function (selector)
        {
            // Stop init if not on the quick entry.
            if ($(selector).find('.checkpointDateSelector').length == 0 && $(selector).find('.ruleTypeSelector').length == 0 && $(selector).find('[id^="TestVersionFieldID-add"][id$="_value"]').length == 0 && $(selector).find('.js-ThresholdTestVersionID').length == 0)
            {
                return;
            }

            // Initialize Date selector trigger
            if ($(selector).find('.checkpointDateSelector').length > 0)
            {
                var element = $(selector).find(".checkpointDateSelector");
                filterData.CheckpointDate = element[0].value.split(' ')[0];
                element.on('change', skyward.mtss.filterDate);
            }

            // Initialize Set All Combo box trigger
            if ($(selector).find('.setAllCheckpointComboBox').length > 0)
            {
                var element = $(selector).find(".setAllCheckpointComboBox");
                element.on('change', skyward.mtss.updateAllComboBoxes);
            }

            // Intitialize Student DMSE trigger
            if ($(selector).find('.checkpointStudentSelector').length > 0)
            {
                var element = $(selector).find('.checkpointStudentSelector');
                filterData.SelectedStudents = element.find(".dmsBackingData").val();
                element.on('change', skyward.mtss.filterStudents);
            }

            // Intitialize Strategy DMSE trigger
            if ($(selector).find('.checkpointStrategySelector').length > 0)
            {
                var element = $(selector).find(".checkpointStrategySelector");
                filterData.SelectedStrategies = element.find(".dmsBackingData").val();
                element.on('change', skyward.mtss.filterStrategies);
            }

            // Intitialize Show All trigger
            if ($(selector).find('.showAllRecords').length > 0)
            {
                var element = $(selector).find(".showAllRecords");
                filterData.ShowAllRecords = element.is(':checked');
                element.on('change', skyward.mtss.filterShowAll);
            }
            if ($(selector).find("#editInterventionPlanMeeting").length > 0) 
            {
                var data = $(selector).find("#editInterventionPlanMeeting").data();
                filterData.Portal = data.portal;
            }
        };

        skyward.mtss.updateAllComboBoxes = function ()
        {
            var comboxBoxAll = $(this);
            var value = comboxBoxAll.val();                                       
            $('[id$="-RecordCode"]').each(function ()
            {
                var checkbox = $(this);
                checkbox.val(value);
                checkbox.change();
            });
        };

        skyward.mtss.filterDate = function ()
        {
            var datePicker = $(this);
            filterData.CheckpointDate = datePicker[0].value.split(' ')[0];
            filterData.SelectedStrategies = null;
            filterData.SelectedStudents = null;
            updateContent();
        };

        skyward.mtss.filterShowAll = function ()
        {
            var checkbox = $(this);
            filterData.ShowAllRecords = checkbox.is(':checked');
            if (!filterData.ShowAllRecords)
            {
                filterData.SelectedStrategies = null;
                filterData.SelectedStudents = null;
            }
            updateContent();
        };

        skyward.mtss.filterStudents = function ()
        {
            var dsme = $(this).find(".dmsBackingData");
            filterData.SelectedStudents = dsme.val();
            updateContent();
        };

        skyward.mtss.filterStrategies = function ()
        {
            var dsme = $(this).find(".dmsBackingData");
            filterData.SelectedStrategies = dsme.val();         
            updateContent();
        };

        skyward.mtss.loadUserChartSettings = function ()
        {
            var buildPopup = function ()
            {
                var button = $('#btnInterventionPlanStrategyUserSettings');
                var accessMode = "";
                if ($("#accessmode").length > 0)
                {
                    accessMode = $("#accessmode").val();
                } 
                var action = "GetUserChartSettings" + accessMode;
                var data = button.data();
                var popupData =
                {
                    interventionplanstrategyid: data.interventionplanstrategyid,
                    interventionplanid: data.interventionplanid,
                    interventionplanstrategyidhash: data.interventionplanstrategyidhash,
                    interventionplanidhash: data.interventionplanidhash
                };

                return $.ajax({
                    url: skyward.global.virtualDir + "MTSS/InterventionPlanStrategyUserSetting/" + action,
                    activityIndicator: { silent: true },
                    type: "POST",
                    dataType: "viewparthtml",
                    data: popupData
                });
            };

            var options =
            {
                draggable: true,
                width: '940px'
            };

            var saveSettingsButton = { id: "saveSettings", text: "Save", click: function () { studentInterventionPlanUserSettingSave(dialog) }, icon: "Save" };
            var cancelButton = { id: "cancelButton", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" };
            var dialog = skyward.modalLayer.showDialog("Settings", buildPopup, [saveSettingsButton, cancelButton], options);
        };

        var studentInterventionPlanUserSettingSave = function (dialog)
        {
            var interventionPlanStrategyUserSetting = dialog.content.find("#interventionPlanStrategyUserSettingPopup");
            var interventionPlanStrategyUserSettingID = interventionPlanStrategyUserSetting.data().interventionplanstrategyusersettingid;
            var accessMode = "";
            if ($("#accessmode").length > 0)
            {
                accessMode = $("#accessmode").val();
            }            

            var chartTypeCodeValue = "";
            var headerLabelValue = "";
            var xAxisLabelValue = "";
            var yAxisLabelValue = "";
            var startDateValue = null;
            var endDateValue = null;
            var includeInNotificationsValue = null;
            var showStartingLineValue = null;
            var showTargetLineValue = null;
            var displayDataPointValuesOnChartValue = null;

            var chartTypeCode = dialog.content.find("#ChartTypeCode");
            var headerLabel = dialog.content.find("#HeaderLabel");
            var xAxisLabel = dialog.content.find("#XAxisLabel");
            var yAxisLabel = dialog.content.find("#YAxisLabel");
            var startDate = dialog.content.find("#StartDate");
            var endDate = dialog.content.find("#EndDate");
            var includeInNotifications = dialog.content.find("#IncludeInNotifications");
            var showStartingLine = dialog.content.find("#ShowStartingLine");
            var showTargetLine = dialog.content.find("#ShowTargetLine");
            var displayDataPointValuesOnChart = dialog.content.find("#DisplayDataPointValuesOnChart");

            if (chartTypeCode.length > 0)
            {
                chartTypeCodeValue = chartTypeCode[0].value;
            }
            if (headerLabel.length > 0)
            {
                headerLabelValue = headerLabel[0].value;
            }
            if (xAxisLabel.length > 0)
            {
                xAxisLabelValue = xAxisLabel[0].value;
            }
            if (yAxisLabel.length > 0)
            {
                yAxisLabelValue = yAxisLabel[0].value;
            }

            if (startDate.length > 0)
            {
                startDateValue = startDate[0].value;
            }
            if (endDate.length > 0)
            {
                endDateValue = endDate[0].value;
            }

            if (includeInNotifications.length > 0)
            {
                includeInNotificationsValue = includeInNotifications[0].checked;
            }

            if (showStartingLine.length > 0)
            {
                showStartingLineValue = showStartingLine[0].checked;
            }

            if (showTargetLine.length > 0)
            {
                showTargetLineValue = showTargetLine[0].checked;
            }

            if (displayDataPointValuesOnChart.length > 0)
            {
                displayDataPointValuesOnChartValue = displayDataPointValuesOnChart[0].checked;
            }


            $.ajax({
                url: skyward.global.virtualDir + "MTSS/InterventionPlanStrategyUserSetting/StudentInterventionPlanUserSettingSave" + accessMode,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    interventionPlanStrategyUserSettingID: interventionPlanStrategyUserSettingID,
                    chartTypeCode: chartTypeCodeValue,
                    headerLabel: headerLabelValue,
                    xAxisLabel: xAxisLabelValue,
                    yAxisLabel: yAxisLabelValue,
                    startDate: startDateValue,
                    endDate: endDateValue,
                    includeInNotifications: includeInNotificationsValue,
                    showStartingLine: showStartingLineValue,
                    showTargetLine: showTargetLineValue,
                    displayDataPointValuesOnChart: displayDataPointValuesOnChartValue,
                },
                success: function (response)
                {
                    if (response.success == true)
                    {
                        location.reload();
                    }
                    else
                    {
                        var baseErrorContainer = dialog.container.find('#InterventionPlanStrategyUserSettingBaseErrorContainer');
                        skyward.validation.displayValidationMessages(response, dialog.container, baseErrorContainer);
                    }
                }
            });
        };

        var updateContent = function ()
        {
            var modals = skyward.modalLayer.getOpenModalLayers();
            var action = 'CheckpointQuickEntry' + filterData.Portal;
                const openLayer = modals.last().data("layer");
            if (!dmseIsOpen && openLayer)
            {
                dmseIsOpen = true;
                const origAfterClose = openLayer.options.afterClose;
                openLayer.options.afterClose = function () {
                    if (typeof origAfterClose === "function") {
                        origAfterClose();
                    }
                    dmseIsOpen = false;
                    skyward.window.loadContent("moduleContent", "MTSS", "InterventionPlanStrategy", action, null, filterData);
                };                
            }
            else if (modals.length < 1)
            {
                skyward.window.loadContent("moduleContent", "MTSS", "InterventionPlanStrategy", action, null, filterData);
            }
        };

        ////Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);
